var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { action, computed, makeObservable } from 'mobx';
import './AspectBackgroundVideo.css';
import { runtime } from '../../../classes/runtime/Runtime';
import { LoadStatus } from '../../../classes/learnware/LearnwareEnums';
let AspectBackgroundVideoIntent_ = class AspectBackgroundVideoIntent_ extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get video() {
        const { intent } = this.props;
        return intent && intent.attachedMedium;
    }
    /*
    get isHidden() {
      const { intent, aspect } = this.props;
      if (intent.loadStatus === LoadStatus.Loading) return true;
      return false;
    }
      visibility: this.isHidden ? 'hidden' : undefined,
  */
    render() {
        if (!runtime.availablePackages.Defer)
            return null;
        const { intent, aspect } = this.props;
        if (!this.video || !this.video.vid)
            return null;
        if (this.video.vid.src.startsWith('data:'))
            return null;
        if (!runtime.streamedPackages.Rare)
            return null;
        const { ReactPlayer } = runtime.availablePackages.Rare.classes;
        return (React.createElement(ReactPlayer, { key: this.video.id, url: this.video.vid.src, className: "stretchVideo", style: {
                position: 'absolute',
                zIndex: 0,
                width: aspect.aspectMount.mountDimensions.aspectWidthInPixel,
                height: aspect.aspectMount.mountDimensions.aspectHeightInPixel,
            }, width: aspect.aspectMount.mountDimensions.aspectWidthInPixel, height: aspect.aspectMount.mountDimensions.aspectHeightInPixel, playing: intent.intentHandler.shouldPlay, loop: false, controls: false, ref: reactPlayer => {
                if (reactPlayer) {
                    intent.reactPlayer = reactPlayer;
                }
            }, progressInterval: 200, onReady: action(() => {
                if (intent.loadStatus === LoadStatus.Loading) {
                    intent.loadStatus = LoadStatus.Ready;
                }
            }), onStart: action(() => {
                const videoHandler = this.video.videoHandler;
                if (videoHandler)
                    videoHandler.onPlay();
                this.video.isPlaying = true;
                this.video.startDate = runtime.runtimeClock.currentDate;
                setTimeout(() => this.onFallbackProgress(videoHandler), 1000);
            }), onPlay: action(() => {
                // this.video.isPlaying = true;
            }), onProgress: ({ played, loaded, loadedSeconds, playedSeconds }) => {
                runtime.runtimeScheduler.addToNextStateChange(() => {
                    this.video.currentPositionInSeconds = playedSeconds;
                    const videoHandler = this.video.videoHandler;
                    if (videoHandler && videoHandler.intent.progressInSeconds < playedSeconds) {
                        videoHandler.intent.loadingPercentage = Math.ceil(loaded * 100);
                        videoHandler.intent.progressInSeconds = playedSeconds;
                    }
                    this.video.checkIfReachedTimeMarks();
                });
                if (!runtime.runtimePermissions.hasEditFunctionality)
                    return;
                if (loaded === 1 && !this.video.vid.durationInSeconds) {
                    this.video.vid.durationInSeconds = loadedSeconds;
                }
            }, onPause: action(() => {
                // this.video.isPlaying = false;
            }), onBuffer: () => { }, onEnded: action(() => {
                this.video.hasEnded = true;
                // this.video.shouldPlayTrigger = false;
                this.video.endDate = runtime.runtimeClock.currentDate;
                const videoHandler = this.video.videoHandler;
                if (videoHandler) {
                    videoHandler.onEnd();
                }
            }), onError: action(e => {
                console.error(e);
                this.video.hasError = true;
            }), onDuration: action((durationInSeconds) => {
                if (!runtime.runtimePermissions.hasEditFunctionality)
                    return;
                if (!isFinite(durationInSeconds))
                    return;
                this.video.vid.durationInSeconds = durationInSeconds;
            }) }));
    }
    // onProgress ist unzuverlässig{
    onFallbackProgress(videoHandler) {
        if (videoHandler) {
            if (videoHandler.intent.progressInSeconds < this.video.vid.durationInSeconds - 1) {
                videoHandler.intent.progressInSeconds++;
                setTimeout(() => this.onFallbackProgress(videoHandler), 1000);
            }
        }
    }
    componentDidMount() {
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            this.video.context.app.stage.stageMountedAspects.mountedAspects.push(this.video.essence);
        });
    }
    componentWillUnmount() {
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            /*  if ([PlayStatus.Pending, PlayStatus.Go, PlayStatus.Playing].includes(this.props.intent.playStatus)) {
              console.log('abort video intent in componentWillUnmount', this.props.intent);
              this.props.intent.playStatus = PlayStatus.Aborted;
            } */
            this.video.context.app.stage.stageMountedAspects.mountedAspects.remove(this.video.essence);
        });
    }
};
__decorate([
    computed
], AspectBackgroundVideoIntent_.prototype, "video", null);
__decorate([
    action.bound
], AspectBackgroundVideoIntent_.prototype, "onFallbackProgress", null);
AspectBackgroundVideoIntent_ = __decorate([
    observer
], AspectBackgroundVideoIntent_);
export { AspectBackgroundVideoIntent_ };
